"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.committee = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.committee = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '1',
        abi: abis_1.abis.Committee,
        address: '0xe18B1361d41afC44658216F3Dc27e48c2336e3c2',
        name: 'Decentraland Collection Committee',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '1',
        abi: abis_1.abis.Committee,
        address: '0xaeec95a8aa671a6d3fec56594827d7804964fa70',
        name: 'Decentraland Collection Committee',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=committee.js.map